export default class DocumentAdapter {
  static global(){
    return window.document;
  }

  static referrer(){
    return this.global().referrer;
  }

  static viewportWidth(){
    return this.global().documentElement.clientWidth;
  }

  static fullscreenElement() {
    return this.global().fullscreenElement;
  }
}
